import { cva, type VariantProps } from "../../lib";

export const screenLayoutContainerVariants = cva("flex-1", {
  variants: {
    background: {
      default: "bg-luce-neutral-background-default",
      intermediate: "bg-luce-neutral-background-intermediate",
      transparent: "bg-transparent",
    },
  },
  defaultVariants: {
    background: "default",
  },
});

export const screenLayoutActionsVariants = cva(
  "gap-spacing-sm px-spacing-lg py-spacing-md relative flex flex-row items-center",
  {
    variants: {
      surface: {
        // The `shadow` surface's shadow is applied per-platform: web adds
        // `shadow-bottombar` (CSS box-shadow), native applies the
        // `nativeShadow` style. NativeWind does not reliably translate a
        // custom boxShadow to a native shadow, so it is not in the cva.
        shadow: "bg-luce-neutral-background-default",
        gradient: "bg-transparent",
        transparent: "bg-transparent",
      },
      roundedTop: {
        true: "rounded-t-radius-lg",
        false: "",
      },
    },
    defaultVariants: {
      surface: "shadow",
      roundedTop: false,
    },
  },
);

/** Gradient overlay rendered above the action bar when `surface="gradient"`. */
export const screenLayoutActionsGradientOverlay =
  "pointer-events-none absolute -top-spacing-xl left-0 right-0 h-spacing-xl bg-gradient-to-b from-transparent to-luce-neutral-background-default";

export type ScreenLayoutContainerVariantsProps = VariantProps<typeof screenLayoutContainerVariants>;
export type ScreenLayoutActionsVariantsProps = VariantProps<typeof screenLayoutActionsVariants>;
